import { api } from '../common.api';

export const profilePictureApi = api.injectEndpoints({
  endpoints: (build) => ({
    uploadProfilePicture: build.mutation<{ profilePictureUrl: string }, { jobseekerId: number; formData: FormData }>({
      query: ({ jobseekerId, formData }) => ({
        url: `/jobseeker/${jobseekerId}/profile-picture/upload`,
        method: 'POST',
        body: formData,
        formData: true,
      }),
      invalidatesTags: ['Jobseeker'],
    }),
    getProfilePicture: build.query<{ profilePictureUrl: string | null }, number>({
      query: (jobseekerId) => ({
        url: `/jobseeker/${jobseekerId}/profile-picture`,
        method: 'GET',
      }),
      providesTags: ['Jobseeker'],
    }),
    getProfilePictureStream: build.query<Blob, number>({
      query: (jobseekerId) => ({
        url: `/jobseeker/${jobseekerId}/profile-picture/stream`,
        method: 'GET',
        responseHandler: async (response: Response) => {
          if (!response.ok) {
            return response.json();
          }
          return response.blob();
        },
      }),
      providesTags: ['Jobseeker'],
    }),
    deleteProfilePicture: build.mutation<{ message: string }, number>({
      query: (jobseekerId) => ({
        url: `/jobseeker/${jobseekerId}/profile-picture`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Jobseeker'],
    }),
  }),
});

export const {
  useUploadProfilePictureMutation,
  useGetProfilePictureQuery,
  useGetProfilePictureStreamQuery,
  useDeleteProfilePictureMutation,
} = profilePictureApi;
